// 협회별 자격증 레벨 데이터
export const certificationLevels: Record<string, Array<{value: string, label: string}>> = {
  AIDA: [
    { value: 'aida1', label: 'AIDA 1' },
    { value: 'aida2', label: 'AIDA 2' },
    { value: 'aida3', label: 'AIDA 3' },
    { value: 'aida4', label: 'AIDA 4' },
    { value: 'aida_instructor', label: 'AIDA Instructor' },
  ],
  PADI: [
    { value: 'padi_basic', label: 'Basic Freediver' },
    { value: 'padi_freediver', label: 'Freediver' },
    { value: 'padi_advanced', label: 'Advanced Freediver' },
    { value: 'padi_master', label: 'Master Freediver' },
    { value: 'padi_instructor', label: 'Freediver Instructor' },
  ],
  SSI: [
    { value: 'ssi_basic', label: 'Basic Freediver' },
    { value: 'ssi_level1', label: 'Level 1' },
    { value: 'ssi_level2', label: 'Level 2' },
    { value: 'ssi_level3', label: 'Level 3' },
    { value: 'ssi_instructor', label: 'Instructor' },
  ],
  CMAS: [
    { value: 'cmas1', label: 'CMAS 1' },
    { value: 'cmas2', label: 'CMAS 2' },
    { value: 'cmas3', label: 'CMAS 3' },
    { value: 'cmas4', label: 'CMAS 4' },
    { value: 'cmas_instructor', label: 'CMAS Instructor' },
  ],
  NAUI: [
    { value: 'naui_skindiver', label: 'Skin Diver' },
    { value: 'naui_freediver', label: 'Freediver' },
    { value: 'naui_advanced', label: 'Advanced Freediver' },
    { value: 'naui_master', label: 'Master Freediver' },
    { value: 'naui_instructor', label: 'Instructor' },
  ],
  SDI: [
    { value: 'sdi_basic', label: 'Basic Freediver' },
    { value: 'sdi_freediver', label: 'Freediver' },
    { value: 'sdi_advanced', label: 'Advanced Freediver' },
    { value: 'sdi_master', label: 'Master Freediver' },
    { value: 'sdi_instructor', label: 'Instructor' },
  ],
  // 직접 입력의 경우 일반적인 레벨
  other: [
    { value: 'beginner', label: '초급' },
    { value: 'intermediate', label: '중급' },
    { value: 'advanced', label: '상급' },
    { value: 'master', label: '마스터' },
    { value: 'instructor', label: '강사' },
  ],
}

// 레벨 표시용 매핑
export const getLevelDisplayName = (level: string): string => {
  const levelMap: Record<string, string> = {
    // AIDA
    'aida1': 'AIDA 1',
    'aida2': 'AIDA 2',
    'aida3': 'AIDA 3',
    'aida4': 'AIDA 4',
    'aida_instructor': 'AIDA Instructor',
    
    // PADI
    'padi_basic': 'Basic Freediver',
    'padi_freediver': 'Freediver',
    'padi_advanced': 'Advanced Freediver',
    'padi_master': 'Master Freediver',
    'padi_instructor': 'Freediver Instructor',
    
    // SSI
    'ssi_basic': 'Basic',
    'ssi_level1': 'Level 1',
    'ssi_level2': 'Level 2',
    'ssi_level3': 'Level 3',
    'ssi_instructor': 'Instructor',
    
    // CMAS
    'cmas1': '1 Star',
    'cmas2': '2 Star',
    'cmas3': '3 Star',
    'cmas4': '4 Star',
    'cmas_instructor': 'Instructor',
    
    // NAUI
    'naui_skindiver': 'Skin Diver',
    'naui_freediver': 'Freediver',
    'naui_advanced': 'Advanced',
    'naui_master': 'Master',
    'naui_instructor': 'Instructor',
    
    // SDI
    'sdi_basic': 'Basic',
    'sdi_freediver': 'Freediver',
    'sdi_advanced': 'Advanced',
    'sdi_master': 'Master',
    'sdi_instructor': 'Instructor',
    
    // 기타
    'beginner': '초급',
    'intermediate': '중급',
    'advanced': '상급',
    'master': '마스터',
    'instructor': '강사',
    
    // 교육생
    'student': '교육생',
  }
  
  return levelMap[level] || level
}